export default __webpack_public_path__ + "assets/ai.0bd1828cb6ec10ad92d900c710079cac.png";